import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { IngredientChoice, IngredientChoiceGroup, IngredientChoicesType, OrderableItem, OrderedItem } from 'ngx-web-api';
import { ViewportService } from 'app/core/services/viewport.service';
import { ItemEditorService } from 'app/core/services/item-editor.service';
import { EditingItemChoicesService } from 'app/core/services/editing-item-choices.service';
import { ViewPort } from 'app/domain/view-port.model';
import { Observable, Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fts-item-editor-modal-footer',
  templateUrl: './item-editor-modal-footer.component.html',
  styleUrls: ['./item-editor-modal-footer.component.scss'],
})
export class ItemEditorModalFooterComponent implements OnInit, OnDestroy {
  @Input()
  hasBackBtn: boolean;
  @Input()
  hasForwardBtn: boolean;
  @Input()
  hasSubmitBtn: boolean;
  @Input()
  forwardBtnItemLabel: string;
  @Input()
  submitBtnLabel: string;
  @Input()
  forwardBtnDisabled: boolean;
  @Input()
  isItemValid: boolean;
  @Input()
  submitLoadingSubscription: Subscription;
  @Input()
  selectedChoiceGroup: IngredientChoiceGroup;
  @Input()
  ingredientChoicesType: IngredientChoicesType;
  @Input()
  hasChoiceGroups: boolean;
  @Input()
  selectedChoice: IngredientChoice;
  @Input()
  isHalfAndHalf = false;

  @Output()
  backBtnClick = new EventEmitter<void>();
  @Output()
  forwardBtnClick = new EventEmitter<void>();
  @Output()
  submitBtnClick = new EventEmitter<void>();
  @Output()
  cancelBtnClick = new EventEmitter<void>();

  @ViewChild('footer', { static: false })
  footer: ElementRef;

  footerTopPosition = 0;
  footerWidth = 0;
  viewPort$: Observable<ViewPort>;
  ingredientChoicesTypeEnum = IngredientChoicesType;
  choiceGroupsHeight: any;

  private orderableItem: OrderableItem;
  private orderedItem: OrderedItem;
  private destroy$ = new Subject<void>();

  constructor(
    public viewportService: ViewportService,
    private itemEditorService: ItemEditorService,
    private editingItemChoices: EditingItemChoicesService
  ) {}

  ngOnInit(): void {
    this.viewPort$ = this.viewportService.viewport$;
    this.itemEditorService.editingItem$
      .pipe(
        filter(ctx => !!ctx),
        takeUntil(this.destroy$)
      )
      .subscribe(ctx => {
        this.orderableItem = ctx.orderableItem;
        this.orderedItem = ctx.orderedItem;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get computedSubmitBtnLabel(): string {
    return this.submitBtnLabel || this.editingItemChoices.getSubmitBtnLabel(this.orderedItem, false);
  }

  onBackBtnClick() {
    this.backBtnClick.emit();
  }

  onForwardBtnClick() {
    this.forwardBtnClick.emit();
  }

  onSubmitBtnClick() {
    if (this.orderableItem && this.orderedItem && !this.isItemValid) {
      this.editingItemChoices.handleInvalidSubmit(this.orderableItem, this.orderedItem, this.ingredientChoicesType);
    }
    this.submitBtnClick.emit();
  }

  onCancelBtnClick() {
    this.cancelBtnClick.emit();
  }
}
